import {
	vec2, vec3,
	mat3
} from './vec'

const π = Math.PI

type keys = '0'|'1'|'2'|'3'|'4'|'5'|'6'|'7'|'8'|'9'|'a'|'b'|'c'|'d'|'e'|'f'|'g'|'h'|'i'|'j'|'k'|'l'|'m'|'n'|'o'|'p'|'q'|'r'|'s'|'t'|'u'|'v'|'w'|'x'|'y'|'z'
let keyList: Array<keys> =['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', 'a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't', 'u', 'v', 'w', 'x', 'y', 'z']

class Sliders {
	0: vec2 = new vec2()
	1: vec2 = new vec2()
	2: vec2 = new vec2()
	3: vec2 = new vec2()
	4: vec2 = new vec2()
	5: vec2 = new vec2()
	6: vec2 = new vec2()
	7: vec2 = new vec2()
	8: vec2 = new vec2()
	9: vec2 = new vec2()
	a: vec2 = new vec2()
	b: vec2 = new vec2()
	c: vec2 = new vec2()
	d: vec2 = new vec2()
	e: vec2 = new vec2()
	f: vec2 = new vec2()
	g: vec2 = new vec2()
	h: vec2 = new vec2()
	i: vec2 = new vec2()
	j: vec2 = new vec2()
	k: vec2 = new vec2()
	l: vec2 = new vec2()
	m: vec2 = new vec2()
	n: vec2 = new vec2()
	o: vec2 = new vec2()
	p: vec2 = new vec2()
	q: vec2 = new vec2()
	r: vec2 = new vec2()
	s: vec2 = new vec2()
	t: vec2 = new vec2()
	u: vec2 = new vec2()
	v: vec2 = new vec2()
	w: vec2 = new vec2()
	x: vec2 = new vec2()
	y: vec2 = new vec2()
	z: vec2 = new vec2()
}

class Rots {
	0: mat3 = new mat3()
	1: mat3 = new mat3()
	2: mat3 = new mat3()
	3: mat3 = new mat3()
	4: mat3 = new mat3()
	5: mat3 = new mat3()
	6: mat3 = new mat3()
	7: mat3 = new mat3()
	8: mat3 = new mat3()
	9: mat3 = new mat3()
	a: mat3 = new mat3()
	b: mat3 = new mat3()
	c: mat3 = new mat3()
	d: mat3 = new mat3()
	e: mat3 = new mat3()
	f: mat3 = new mat3()
	g: mat3 = new mat3()
	h: mat3 = new mat3()
	i: mat3 = new mat3()
	j: mat3 = new mat3()
	k: mat3 = new mat3()
	l: mat3 = new mat3()
	m: mat3 = new mat3()
	n: mat3 = new mat3()
	o: mat3 = new mat3()
	p: mat3 = new mat3()
	q: mat3 = new mat3()
	r: mat3 = new mat3()
	s: mat3 = new mat3()
	t: mat3 = new mat3()
	u: mat3 = new mat3()
	v: mat3 = new mat3()
	w: mat3 = new mat3()
	x: mat3 = new mat3()
	y: mat3 = new mat3()
	z: mat3 = new mat3()
}

export class Interact {
	static keyList: Array<string> = keyList

	static keystate: Record<string,boolean> = {}
	sliders: Sliders = new Sliders()
	rots: Rots = new Rots()

	viewP: vec3 = new vec3()
	viewR: mat3 = new mat3()
	viewZ: number = 0

	target: HTMLElement
	lockPointer() { this.target.requestPointerLock() }
	lockPointerExit() { document.exitPointerLock() }

	constructor(target: HTMLElement = document.body) {
		let self = this
		this.target = target
		function helper(event: KeyboardEvent, state: boolean) {
			let k = event.key.toLowerCase()
			if (k == 'meta') { k = 'alt' }
			if (state) { Interact.keystate[k] = state }
			else { delete Interact.keystate[k] }
	
			// TODO smooth transition

			if(event.shiftKey) {
				if (event.code == 'Digit1') self.viewR = mat3.rot(new vec3(π, 0, 0)) // TODO check
				if (event.code == 'Digit2') self.viewR = mat3.rot(new vec3(0, 0, -π / 2)) // TODO check
				if (event.code == 'Digit3') self.viewR = mat3.rot(new vec3(0, -π / 2, 0)) // TODO check
			} else {
				if (event.code == 'Digit1') self.viewR = new mat3() // TODO check
				if (event.code == 'Digit2') self.viewR = mat3.rot(new vec3(0, 0, π / 2)) // TODO check
				if (event.code == 'Digit3') self.viewR = mat3.rot(new vec3(0, π / 2, 0)) // TODO check
			}

			// TODO : store some views on numbers

			// TODO : ctrl+1       : set current view to front view
			// TODO : ctrl+shift+1 : set current view to back view
			// TODO : etc...
		}
		window.addEventListener('keydown', event => helper(event, true))
		window.addEventListener('keyup', event => helper(event, false))
		window.addEventListener("blur", e => {
			for( let k in Interact.keystate) {
				delete Interact.keystate[k]
			}
		})
		// let scrollPage = (e: MouseEvent) => {
		// 	if (Interact.keystate["control"] || Interact.keystate["shift"] || Interact.keystate["alt"] || Interact.alphabetKeyIsDown()) {
		// 	} else {
		// 		window.scroll( window.scrollX - e.movementX, window.scrollY - e.movementY)
		// 	}
		// }
		// window.addEventListener("mousedown", e => {
		// 	if(e.button==1) { // middlemouse
		// 		this.lockPointer()
		// 		window.addEventListener("mousemove", scrollPage )
		// 	}
		// })
		// window.addEventListener("mouseup", e => {
		// 	if(e.button==1) { // middlemouse
		// 		this.lockPointerExit()
		// 		window.removeEventListener("mousemove", scrollPage )
		// 	}
		// })
		let middleScroll = (e: MouseEvent|WheelEvent) => {
			let scrollFactor = 1/200
			if (e instanceof WheelEvent && e.deltaMode==1) {
				// I think some people at mozilla are idiots https://bugzilla.mozilla.org/show_bug.cgi?id=1392460
				scrollFactor = 1/20
			}
			console.log(e)
			for(let k in Interact.keystate) {
				e.preventDefault() // TODO only when a key is pressed
			}
			let dx = -e.movementX/100
			let dy = +e.movementY/100
			if (e instanceof WheelEvent) {
				dx += e .deltaX*scrollFactor
				dy -= e .deltaY*scrollFactor
			}

			if (Interact.keystate['control']) this.viewZ += -dy
			let z = Math.exp(this.viewZ)

			let r = mat3.rot(new vec3(0, dy*z, dx*z))
			if (Interact.keystate['shift']) r = mat3.rot(new vec3(- dy - dx, 0, 0))
			if (Interact.keystate['alt']) this.viewR = r.mult(this.viewR)
			for( let k in Interact.keystate) {
				switch(k) {
					case '0':
					case '1':
					case '2':
					case '3':
					case '4':
					case '5':
					case '6':
					case '7':
					case '8':
					case '9':
					case 'a':
					case 'b':
					case 'c':
					case 'd':
					case 'e':
					case 'f':
					case 'g':
					case 'h':
					case 'i':
					case 'j':
					case 'k':
					case 'l':
					case 'm':
					case 'n':
					case 'o':
					case 'p':
					case 'q':
					case 'r':
					case 's':
					case 't':
					case 'u':
					case 'v':
					case 'w':
					case 'x':
					case 'y':
					case 'z':
						this.sliders[k] = this.sliders[k].add(new vec2(dx, dy))
						this.rots[k] = r.mult(this.rots[k])
						console.log(`${k} = [${this.sliders[k][0].toFixed(3)},${this.sliders[k][1].toFixed(3)}]`)
						// console.log(`rot_${k} = [${this.rots[k].map(x => x.toFixed(3)).join(',')}]`)
						// console.log(this.rots[k].map(e=>e.toFixed(3)))
				}
			}
			// TODO : 3d translation
			this.viewP = this.viewP.add(new vec3(dx,dy,0)) // TODO this is wrong !
		}
		target.addEventListener("mousedown", e => {
			if (e.button == 1) { // middlemouse
				this.lockPointer()
				target.addEventListener("mousemove", middleScroll)
			}
		})
		window.addEventListener("mouseup", e => {
			if (e.button == 1) { // middlemouse
				this.lockPointerExit()
				target.removeEventListener("mousemove", middleScroll)
			}
		})
		target.addEventListener("wheel", middleScroll, { passive: false })
	}
}

//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
// if (Interact.kbd.state["Shift"]) {
// 	let T = m4.translation([x / 2., y / 2., 0]);
// 	m4.multiply(T, view, view);
// }
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
// let x = -e.movementX / 100.;
// let y = e.movementY / 100.;
// if (e.deltaX) { x += e.deltaX / 200.; }
// if (e.deltaY) { y += -e.deltaY / 200.; }
// if (key == undefined && Interact.kbd.alphabetKeyIsDown()) {return}
// if (key != undefined && !Interact.kbd.state[key]) {return}
// let v = [y, x, 0];
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////
//////////////////////////////////////////////////////////////

export class Player {
	time: number = 0
	playRate: number = 0

	constructor(keyStop='h',keyRewind='j',keyPause='k',keyPlay='l') {
		window.addEventListener("keydown", e => {
			// console.log(e)
			if (e.shiftKey) {
				if (e.key.toLowerCase() == keyStop) this.stop()
				if (e.key.toLowerCase() == keyPlay) this.play_faster()
				if (e.key.toLowerCase() == keyPause) this.pause()
				if (e.key.toLowerCase() == keyRewind) this.rewind_faster()
			} else {
				if (e.key.toLowerCase() == keyStop) this.stop()
				if (e.key.toLowerCase() == keyPlay) this.play()
				if (e.key.toLowerCase() == keyPause) this.pause()
				if (e.key.toLowerCase() == keyRewind) this.rewind()
			}
		})

		let self = this
		function update() {
			let now = new Date().getTime()
			let dt = (now - self.previousTime) / 1000
			self.previousTime = now
			self.time += dt * self.playRate
			if (self.time < 0) {
				self.time = 0
				self.playRate = 0
			}
			console.log(self.time)
			window.requestAnimationFrame(update)
		}
		update()
	}

	play()          { this.playRate  = 1 }
	play_faster()   { this.playRate += 3 }
	rewind()        { this.playRate  =-1 }
	rewind_faster() { this.playRate -= 3 }
	pause()         { this.playRate  = 0 }
	stop()          { this.playRate  = 0 ; this.time = 0 }

	previousTime = new Date().getTime()
}
